module.exports = __webpack_public_path__ + "img/santander.1a9fb009.svg";